import { render, staticRenderFns } from "./OrderItem.vue?vue&type=template&id=2f15b138&"
import script from "./OrderItem.vue?vue&type=script&lang=js&"
export * from "./OrderItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports